export default __webpack_public_path__ + "static/media/Background_00202.501c8543.png";